import { ReactElement, ReactNode } from "react";

export default function BottomBar({ children }: { children: ReactNode }) {
  return <div className="w-full p-6 bg-ldir-blue-900 bottom-0 mt-6 flex z-20">{children}</div>;
}

interface props {
  buttonOne: ReactElement;
  buttonTwo: ReactElement;
  darkBg?: boolean;
}

export function BottomBarDouble(props: props) {
  return (
    <div
      id={"bottom-bar"}
      className={`py-3 px-4 flex justify-between sticky bottom-0 flex-wrap ${
        props.darkBg ? "bg-ldir-blue-900" : "bg-ldir-gray-600"
      }`}
    >
      <div className="min-w-fit w-2/5">{props.buttonOne}</div>
      <div className="min-w-fit w-2/5">{props.buttonTwo}</div>
    </div>
  );
}
